import { FC } from 'react';

type Props = {
	className?: string;
};

const ArrowUpRightIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M14.168 5.83333L5.00129 15'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M14.8904 10.8335C14.8904 10.8335 15.2861 6.13891 14.5737 5.42641C13.8613 4.714 9.16664 5.10983 9.16664 5.10983'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ArrowUpRightIcon;
